import { Link } from 'react-router-dom';

/**
 * Footer legal minimaliste : copyright + liens CGU / Privacy / Mentions / Contact.
 * A wiring dans app-shell par Nicolas (remplace le footer "v0.1.0 - alpha" actuel).
 *
 * Choix contraste : on utilise `text-foreground/70` plutot que `text-muted-foreground`
 * pour ces liens car ce sont des liens legaux importants qui doivent rester
 * lisibles (RGPD impose un acces visible aux CGU/Privacy/Mentions).
 */
export function LegalFooter() {
  return (
    <footer className="border-t border-border mt-auto">
      <div className="container mx-auto py-4 px-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-foreground/70">
        <div className="flex items-center gap-2">
          <span>© Black Potion 2026</span>
          <span className="hidden sm:inline">-</span>
          <span className="italic">Beta gratuite</span>
          <span
            aria-label="Réservé aux 18 ans et plus"
            className="inline-flex items-center px-1.5 py-0.5 text-[10px] font-bold rounded border border-primary/40 text-primary"
          >
            18+
          </span>
        </div>

        <nav
          aria-label="Liens légaux"
          className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1"
        >
          <Link
            to="/legal/cgu"
            className="underline-offset-4 hover:underline hover:text-foreground transition-colors"
          >
            CGU
          </Link>
          <Link
            to="/legal/confidentialite"
            className="underline-offset-4 hover:underline hover:text-foreground transition-colors"
          >
            Confidentialité
          </Link>
          <Link
            to="/legal/mentions"
            className="underline-offset-4 hover:underline hover:text-foreground transition-colors"
          >
            Mentions légales
          </Link>
          <a
            href="mailto:kavaliero37@gmail.com"
            className="underline-offset-4 hover:underline hover:text-foreground transition-colors"
          >
            Contact
          </a>
        </nav>
      </div>
    </footer>
  );
}
